export let feedbackLink = "Dtuepd";
export default {feedbackLink};